<template>
<div class="vote">
    <!-- TODO: Highlight me somehow -->
    <!-- <p v-show="broadcasterUpvoted" class="broadcaster-likes help">
            {{ $t('xLikesThis', [channel.channelName]) }}
        </p> -->
    <span
        v-require-identity
        @click="onVote($const.VOTE_UP)"
        v-bind="upvoteAttr"
        class="upvote icon">
        <FaIcon :icon="upvoteIcon" class="has-text-theme"/>
        <transition name="fade">
            <BroadcasterLikesIcon v-if="broadcasterUpvoted" />
        </transition>
    </span>
    <span class="vote-score">
        {{ suggestion.numUpvotes | bigNumber }}
    </span>
    <span
        v-require-identity
        @click="onVote($const.VOTE_DOWN)"
        class="icon">
        <FaIcon :icon="downvoteIcon" class="has-text-theme"/>
    </span>
</div>
</template>

<script>
/*
Implements Youtube style voting.

2020-03-27 Note: I first tried displaying voteScore (numUpvotes - numDownvotes)
instead of numUpvotes. But, when user changes an upvote to a downvote,
or vice versa, the number would change by 2. The math checks out, but it looks buggy.
So for now, just query for, and display numUpvotes. Much simpler.
*/
import { mapGetters } from 'vuex'

import { VOTE_UP, VOTE_DOWN, VOTE_NONE } from '@shared/constants'
import BroadcasterLikesIcon from '@/components/viewer/BroadcasterLikesIcon'

const T_UP = 'thumbs-up'
const T_DOWN = 'thumbs-down'

export default {
    name: 'Vote',
    props: {
        suggestion: Object,
        broadcasterUser: Object,
        broadcasterUpvoted: Boolean,
    },
    computed: {
        ...mapGetters(['isGuanzoUser']),
        userVoteType: vm => vm.suggestion.userVoteType,
        userUpvoted: vm => vm.userVoteType === VOTE_UP,
        userDownvoted: vm => vm.userVoteType === VOTE_DOWN,
        upvoteIcon: vm => vm.userUpvoted ? T_UP : ['far', T_UP],
        downvoteIcon: vm => vm.userDownvoted ? T_DOWN : ['far', T_DOWN],
        upvoteAttr: vm => {
            const text = `${vm.broadcasterUser.name} likes this`
            return vm.broadcasterUpvoted ? { 'data-tippy-content': text } : {}
        },
    },
    methods: {
        onVote (clickedVoteType) {
            const currentVoteType = this.userVoteType
            let newVoteType

            if (clickedVoteType === VOTE_UP) {
                if (currentVoteType === VOTE_UP) {
                    newVoteType = VOTE_NONE // undo
                } else {
                    newVoteType = VOTE_UP
                }
            } else if (clickedVoteType === VOTE_DOWN) {
                if (currentVoteType === VOTE_DOWN) {
                    newVoteType = VOTE_NONE // undo
                } else {
                    newVoteType = VOTE_DOWN
                }
            }

            const payload = {
                suggestionId: this.suggestion.id,
                voteType: newVoteType,
                previousVoteType: currentVoteType,
            }
            this.$store.dispatch('saveVote', payload)
        },
    },
    components: {
        BroadcasterLikesIcon,
    }
}

</script>

<style lang="scss" scoped>
.vote {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: 4px;
    margin-bottom: 2px;
    height: $emote-reaction-size;
    .icon {
        cursor: pointer;
    }
    // copy youtube downvote style
    svg.fa-thumbs-down{
        transform: translateY(2px) rotateY(180deg);
    }
    .vote-score {
        font-size: 0.8rem;
        padding-left: 0.1rem;
        padding-right: 0.25rem;
    }
}

.upvote {
    position: relative;
    .broadcaster-likes-icon {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -10px);
    }
}
</style>
